import { useEffect, useState } from 'react'
import { api } from '../api.js'

export default function Dossier({ id, onRetour }) {
  const [d, setD] = useState(null)
  const [motif, setMotif] = useState('')
  const [action, setAction] = useState(null)
  const [erreur, setErreur] = useState('')

  const charger = () => api.request(id).then(setD).catch((e) => setErreur(e.message))
  useEffect(() => { charger() }, [id])   // eslint-disable-line

  if (erreur) return <p className="erreur">{erreur}</p>
  if (!d) return <p className="chargement">Chargement…</p>

  async function lancer(a) {
    if ((a.require_comment || a.type === 'ask_user') && !motif.trim()) { setAction(a); return }
    try {
      await api.action(id, a.id, motif)
      setMotif(''); setAction(null); charger()
    } catch (e) { setErreur(e.message) }
  }

  return (
    <>
      <button className="retour" onClick={onRetour}>← Retour aux dossiers</button>

      {d.alerts?.map((a, i) => <div className="alerte" key={i} role="status">{a}</div>)}

      <header className="cartouche">
        <p className="ref">DOSSIER N° {d.number} · déposé le {new Date(d.updated_at).toLocaleDateString('fr-FR')}</p>
        <h1>{d.title}</h1>
        <p className="meta">
          <span>Demandeur <strong>{d.applicant?.name}</strong></span>
          <span>Courriel <strong>{d.applicant?.email || '-'}</strong></span>
        </p>
        <span className="tampon">{d.status}</span>
      </header>

      <div className="deux">
        <section>
          {d.awaiting_detail && (
            <div className="carte attente-bloc">
              <h2>En attente de l'habitant</h2>
              <p>{d.awaiting_detail.question}</p>
            </div>
          )}

          <div className="carte">
            <h2>Ce qui a été transmis</h2>
            <table className="recap">
              <tbody>
                {d.fields.map((f) => (
                  <tr key={f.varname}>
                    <th scope="row">{f.label}</th>
                    <td>{Array.isArray(d.data[f.varname]) ? d.data[f.varname].join(', ')
                      : d.data[f.varname] || <em>non renseigné</em>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="carte">
            <h2>Registre du dossier</h2>
            <ol className="journal">
              {[...d.events].reverse().map((e, i) => (
                <li key={i}>
                  <time>{new Date(e.at).toLocaleString('fr-FR')}</time>
                  <strong>{e.title}</strong>{!e.public && <span className="interne">interne</span>}
                  {e.body && <p>{e.body}</p>}
                </li>
              ))}
            </ol>
          </div>
        </section>

        <aside>
          <div className="carte">
            <h2>Actions</h2>
            {d.help && <p className="aide">{d.help}</p>}
            {action && (
              <div className="champ">
                <label htmlFor="motif">
                  {action.type === 'ask_user' ? "Que demandez-vous à l'habitant ?" : 'Motif transmis'}
                </label>
                <textarea id="motif" rows={3} value={motif} autoFocus
                          onChange={(e) => setMotif(e.target.value)} />
                <button className="btn pri" onClick={() => lancer(action)}>{action.label}</button>
                <button className="btn" onClick={() => { setAction(null); setMotif('') }}>Annuler</button>
              </div>
            )}
            {!action && (d.actions.length
              ? d.actions.map((a) => (
                  <button key={a.id} className={`btn large ${a.tone === 'pri' ? 'pri' : a.tone === 'dgr' ? 'dgr' : ''}`}
                          onClick={() => lancer(a)}>{a.label}</button>
                ))
              : <p className="aide">Aucune action disponible à cette étape.</p>)}
          </div>

          <div className="carte">
            <h2>Envois</h2>
            {d.outbox.length ? d.outbox.map((m, i) => (
              <details key={i}>
                <summary>{m.subject}</summary>
                <p className="mono petit">{m.to} · {m.sent ? 'envoyé' : m.error || 'en attente'}</p>
                <pre>{m.body}</pre>
              </details>
            )) : <p className="aide">Rien n'est encore parti.</p>}
          </div>
        </aside>
      </div>
    </>
  )
}
